import React from 'react';
import MuiListItemAvatar, { ListItemAvatarProps } from '@mui/material/ListItemAvatar';

export type { ListItemAvatarProps };

export const ListItemAvatar: React.FC<ListItemAvatarProps> = (props) => {
  const { children, ...restProps } = props;
  return <MuiListItemAvatar {...restProps}>{children}</MuiListItemAvatar>;
};
